
import Chart from 'react-apexcharts';

const DeliveredPercentageChart = ({ percentage = 0 }) => {

    const options = {
        chart: {
            type: 'radialBar',
        },
        plotOptions: {
            radialBar: {
                hollow: {
                    size: '60%',
                },
                dataLabels: {
                    name: { show: false },
                    value: {
                        fontSize: '20px',
                        formatter: (val) => `${val}%`,
                    },
                },
            },
        },
        // The important part: color and fill settings go here
        colors: ['#008FFB'],  // color of the radial bar
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                type: 'horizontal',
                gradientToColors: ['#87D4F9'], // end color
                stops: [0, 100],
            },
        },
        labels: ['Delivered Percentage'],
    };


    return (
        <div style={{ width: 250, height: 250 }}>
            <Chart
                options={options}
                series={[percentage]}
                type="radialBar"
                height={250}
            />
        </div>
    );
}

export default DeliveredPercentageChart;
